import { axiosInstanceV2 } from '@/service/axios';
import { snakeCaseDictToCamelCaseDict, getPaginatedEndpoint } from '@/service/utils';
import {
  ICheckReferralPayload,
  ICreateReferralPayload,
  IReferral,
  IReferralAgreement,
  IReferralSummary,
} from './types';
import { PaginatedResponse } from '../types';

export async function getReferralAgreements(): Promise<IReferralAgreement[]> {
  return axiosInstanceV2
    .get('/referral/agreements/')
    .then(({ data }) => snakeCaseDictToCamelCaseDict(data) as IReferralAgreement[]);
}

export async function checkReferral(payload: ICheckReferralPayload): Promise<{ status: string }> {
  return axiosInstanceV2.post('/referral/check/', payload).then(({ data }) => data);
}

export async function createReferral(payload: ICreateReferralPayload): Promise<IReferral> {
  return axiosInstanceV2
    .post('/referral/', payload)
    .then(({ data }) => snakeCaseDictToCamelCaseDict(data) as IReferral);
}

export async function getReferrals(params: { search?: string } = {}): Promise<PaginatedResponse<IReferral>> {
  const cleanParams: { search?: string } = {};

  if (params.search) {
    cleanParams.search = params.search;
  }

  return getPaginatedEndpoint<IReferral>('/referral/', cleanParams, axiosInstanceV2);
}

export async function getReferralSummary(): Promise<IReferralSummary> {
  return axiosInstanceV2
    .get('/referral/summary/')
    .then(({ data }) => snakeCaseDictToCamelCaseDict(data) as IReferralSummary);
}
